import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik'
import CityAutocompleteField from '../../../modules/auth/components/fields/CityAutocompleteField'
import { useEffect, useState } from 'react'
import { IndustriesAutocompleteField } from './fields/IndustriesAutocompleteField'
import { updateProfileProfessional } from '../../../services/profileAdminService'
import { useHistory } from 'react-router-dom'
import { useUserProfileContext } from '../../../context/UserProfileContext'
import { useAlert } from '../../../hooks/utils/useAlert'
import * as Yup from 'yup'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { KTSVG } from '../../../../_metronic/helpers'
import { RequiredInfoModal } from '../../../helpers/RequiredInfoModal'
import { showErrorAlert } from '../../../helpers/alert'
import { getProfessionalInterests } from '../../../services/componentsService'

export default function ProfessionalOverviewForm() {
    const [loading, setLoading] = useState(false)
    const navigate = useHistory()
    const { refetch, searchParams, data } = useUserProfileContext()
    const { showError } = useAlert()
    const [showModal, setShowModal] = useState(false);
    const [messageModal, setMessageModal] = useState("");
    const [allInterests, setAllInterests] = useState([]);
    const [selectedInterests, setSelectedInterests] = useState([]);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        getInterest();
    },[])

    const getInterest = async () => {
        const data_ = await getProfessionalInterests();
        const result = (data_ ?? []).map((item) => item.name);
        const selectedInterests_ = (data?.professionalProfile?.professionalInterest ?? []).filter(interest =>
            result.some(ai => ai.trim().toLowerCase() === interest.trim().toLowerCase())
        );
        setSelectedInterests(selectedInterests_);
        setAllInterests(result);
        setReady(true);
    }

    const initialValues = {
        industries: data?.professionalProfile?.industries ?? [],
        professional_interest: selectedInterests,
        work_positions: (data?.professionalProfile?.workPositions || []).map((item)=>{return {company: item?.company, position: item?.position, description: item?.description || '', city: (item?.city), from_year: (item?.fromYear || ''),to_year: (item?.toYear == 'Present' ? '' : item?.toYear), current_role: !!item?.currentRole, website: item?.website ?? '' };}),
        on_board: (data?.professionalProfile?.onBoard || []).map((item)=>{return {company: item?.company, position: item?.position, description: item?.description || '', city: (item?.city), from_year: (item?.fromYear || ''),to_year: (item?.toYear == 'Present' ? '' : item?.toYear), current_role: !!item?.currentRole, website: item?.website ?? '' };}),
        non_profit_involvement: (data?.professionalProfile?.nonProfitInvolvement || []).map((item)=>{return {company: item?.company, position: item?.position, description: item?.description || '', city: (item?.city), from_year: (item?.fromYear || ''),to_year: (item?.toYear == 'Present' ? '' : item?.toYear), current_role: !!item?.currentRole, website: item?.website ?? '' };}),
        education: (data?.professionalProfile?.education || []).map((item) => {
            const { carreer, ...rest } = item ?? {}
            return { degree: carreer ?? '', description: item?.description || '', university_name: item?.universityName, city: (item?.city), from_year: (item?.fromYear || ''), to_year: (item?.toYear == 'Present' ? '' : item?.toYear), current_role: !!item?.currentRole, website: item?.website ?? '' };
        }),
    }

    const validationSchema = Yup.object({
        industries: Yup.array().of(
            Yup.string().max(100, "Max 100 characters"),
        ).nullable(),
        professional_interest: Yup.array().of(
            Yup.string().max(100, "Max 100 characters"),
        ).nullable(),
        work_positions: Yup.array().of(
            Yup.object().shape({
                company: Yup.string().required("Company is required").max(220, "Max 220 characters"),
                position: Yup.string().required("Position is required").max(220, "Max 220 characters"),
                description: Yup.string().max(500, "Max 500 characters"),
                city: Yup.string().nullable().max(220, "Max 220 characters"),
                current_role: Yup.boolean().default(false),
                from_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                }),
                to_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                })
                .when('current_role', {
                    is: true,
                    then: (schema) => schema.notRequired(),
                    otherwise: (schema) =>
                        schema
                            .test(
                                'is-after-start',
                                'End year must be after start year.',
                                function (value) {
                                    const { from_year } = this.parent
                                    if (from_year == null || value == null) return true
                                    return value >= from_year
                                }
                            ),
                }),
                website: Yup.string().url('web url is required').max(220, "Max 220 characters").notRequired(),
            })
        )/* .min(1, "At least one work positions is required") */,
        on_board: Yup.array().of(
            Yup.object().shape({
                company: Yup.string().required("Company is required").max(220, "Max 220 characters"),
                position: Yup.string().required("Position is required").max(220, "Max 220 characters"),
                description: Yup.string().max(500, "Max 500 characters"),
                city: Yup.string().nullable().max(220, "Max 220 characters"),
                current_role: Yup.boolean().default(false),
                from_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                }),
                to_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                })
                .when('current_role', {
                    is: true,
                    then: (schema) => schema.notRequired(),
                    otherwise: (schema) =>
                        schema
                            .test(
                                'is-after-start',
                                'End year must be after start year.',
                                function (value) {
                                    const { from_year } = this.parent
                                    if (from_year == null || value == null) return true
                                    return value >= from_year
                                }
                            ),
                }),
                website: Yup.string().url('web url is required').max(220, "Max 220 characters"),
            })
        )/* .min(1, "At least one board is required") */,
        non_profit_involvement: Yup.array().of(
            Yup.object().shape({
                company: Yup.string().required("Company is required").max(220, "Max 220 characters"),
                position: Yup.string().required("Position is required").max(220, "Max 220 characters"),
                description: Yup.string().max(500, "Max 500 characters"),
                city: Yup.string().nullable().max(220, "Max 220 characters"),
                current_role: Yup.boolean().default(false),
                from_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                }),
                to_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                })
                .when('current_role', {
                    is: true,
                    then: (schema) => schema.notRequired(),
                    otherwise: (schema) =>
                        schema
                            .test(
                                'is-after-start',
                                'End year must be after start year.',
                                function (value) {
                                    const { from_year } = this.parent
                                    if (from_year == null || value == null) return true
                                    return value >= from_year
                                }
                            ),
                }),
                website: Yup.string().url('web url is required').max(220, "Max 220 characters"),
            })
        )/* .min(1, "At least one non profit or charitable organization is required") */,
        education: Yup.array().of(
            Yup.object().shape({
                university_name: Yup.string().required("University is required").max(220, "Max 220 characters"),
                degree: Yup.string().required("Degree is required").max(220, "Max 220 characters"),
                description: Yup.string().max(500, "Max 500 characters"),
                city: Yup.string().nullable().max(220, "Max 220 characters"),
                current_role: Yup.boolean().default(false),
                from_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                }),
                to_year: Yup.number().nullable().transform((value, originalValue) => {
                    if (originalValue === "" || originalValue == null) return null;
                    return isNaN(value) ? null : value;
                }).when('current_role', {
                    is: true,
                    then: (schema) => schema.notRequired(),
                    otherwise: (schema) =>
                        schema
                            .test(
                                'is-after-start',
                                'End year must be after start year.',
                                function (value) {
                                    const { from_year } = this.parent
                                    if (from_year == null || value == null) return true
                                    return value >= from_year
                                }
                            ),
                }),
                website: Yup.string().url('web url is required').max(220, "Max 220 characters"),
            })
        )/* .min(1, "At least one non profit or charitable organization is required") */,
    })

    if(!ready) return null;

    return (<>
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
                try {
                    setLoading(true)
                    const payload = {
                        ...values,
                        education: values.education.map(({ degree, ...rest }) => ({ ...rest, carreer: degree })),
                    };
                    let isUpdate = await updateProfileProfessional(
                        payload,
                        !!searchParams.userSelected ? searchParams.userSelected : ''
                    )
                    if(isUpdate?.success || isUpdate?.email || isUpdate){
                        showErrorAlert({title:'Saved',message:'Your information has been saved successfully.'});
                    }
                    setLoading(false)
                    await refetch()
                    navigate.goBack()
                } catch (error: any) {
                    const statusCode = error?.response?.status || 500
                    showError({
                        title: 'Unable to update professional overview',
                        message: "We couldn't save your changes. Please review your information and try again.",
                        errorCode: `PROFESSIONAL_OVERVIEW_${statusCode}`,
                    })
                } finally {
                    setLoading(false)
                }
            }}
        >
            {(formik) => {
                const focusFirstError = async () => {
                    const errors = await formik.validateForm();
                    const firstErrorPath = findFirstErrorPath(errors);

                    if (firstErrorPath) {
                        formik.setTouched(touchAll(formik.values))
                        setMessageModal(`Please check the field error '${firstErrorPath.replaceAll('_', ' ')}' to save your progress.`)
                        const el = document.querySelector(`[name="${firstErrorPath}"]`) as HTMLElement
                        setShowModal(true)
                        el?.focus()
                        return
                    }

                    formik.submitForm()
                }

                const touchAll = (values: any): any => {
                    if (Array.isArray(values)) {
                        return values.map((v) => touchAll(v))
                    }
                    if (typeof values === 'object' && values !== null) {
                        return Object.keys(values).reduce((acc, key) => {
                            acc[key] = touchAll(values[key])
                            return acc
                        }, {} as any)
                    }
                    return true
                }

                const findFirstErrorPath = (errors: any, path = ''): string | null => {
                    if (typeof errors === 'string') {
                    return path
                    }

                    if (Array.isArray(errors)) {
                        for (let i = 0; i < errors.length; i++) {
                            const res = findFirstErrorPath(
                            errors[i],
                            `#${i+1}`
                            )
                            if (res) return res
                        }
                    }

                    if (typeof errors === 'object' && errors !== null) {
                        for (const key of Object.keys(errors)) {
                            const res = findFirstErrorPath(
                            errors[key],
                            path ? `${key} ${path}` : key
                            )
                            if (res) return res
                        }
                    }

                    return null
                }

                const toggleInterest = (interest: string) => {
                    const interests = formik.values.professional_interest || []
                    if (interests.includes(interest)) {
                    // remover
                        formik.setFieldValue('professional_interest',interests.filter((i) => i !== interest))
                    } else {
                        // agregar
                        formik.setFieldValue('professional_interest',[...interests, interest])
                    }
                }

                const setSelectedIndustries = (values:string[]) => {
                    formik.setFieldValue('industries',values);
                }

                return (<Form className='pf-form'>
                    {/* Header */}
                    <div className='pf-header'>Edit Your Professional Overview</div>

                    {/* Organizations */}
                    <div className='pf-section__title'>Organizations I am involve in / Positions</div>
                    <div className='d-flex flex-column w-100'>
                        <FieldArray name="work_positions">
                            {({ push, remove }) => (<>
                                <div className='d-flex flex-column w-100'>    
                                    {(formik.values.work_positions ?? []).map((item, index) => (
                                        <div key={`work_positions_${index}`} className={`pf-section mb-4 ${index>0 ? 'mt-4' : ''}`}>
                                            <div className='d-flex flex-row justify-content-between w-100'>
                                                <div className='pf-section__title'>Positions {`(${index+1})`}</div>
                                                <button type="button" onClick={() => remove(index)} className="remove-btn tap-flex-center">
                                                    <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_delete.svg' />&nbsp;
                                                </button>
                                            </div>
                                            <div className={`pf-section__desc ${index>0 ? 'd-none' : ''}`}>
                                                Please list all relevant organizations you’d like to showcase in your profile, both
                                                current and past.
                                            </div>

                                            <div className='pf-fields'>
                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Organization</label>
                                                        <Field name={`work_positions[${index}].company`} className='pf-input' />
                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Role</label>
                                                        <Field name={`work_positions[${index}].position`} className='pf-input' />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`work_positions[${index}].company`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`work_positions[${index}].position`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <div className='recognition-form__field-wrapper w-100'>
                                                        <div className='pf-field'>
                                                            <label className='pf-label'>Description</label>
                                                        </div>
                                                        <div className='recognition-form__textarea-wrapper'>
                                                            <Field
                                                                as='textarea'
                                                                name={`work_positions[${index}].description`}
                                                                maxLength={500}
                                                                className='recognition-form__textarea' />
                                                            </div>
                                                            <div className='recognition-form__counter'>
                                                            <span className='recognition-form__counter-placeholder'>
                                                                Description
                                                            </span>
                                                            <span className='recognition-form__counter-text'>
                                                                {formik.values.work_positions[index]?.description?.length || 0}/500
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`work_positions[${index}].description`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>
                                                <div className='pf-field'>
                                                    <label className='pf-label'>City</label>
                                                    <CityAutocompleteField name={`work_positions[${index}].city`} />
                                                    <ErrorMessage name={`work_positions[${index}].city`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <label className='pf-checkbox' style={{ cursor: 'pointer' }}>
                                                    <Field type='checkbox' name={`work_positions[${index}].current_role`} className='pf-check' />
                                                    <span>I am currently serving in this role</span>
                                                </label>

                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>From</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.from_year
                                                                ? dayjs(item.from_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `work_positions[${index}].from_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />
                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>To</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.to_year
                                                                ? dayjs(item.to_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `work_positions[${index}].to_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`work_positions[${index}].from_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`work_positions[${index}].to_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>Website url</label>
                                                    <Field name={`work_positions[${index}].website`} className='pf-input' />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='pf-add' onClick={() => push({ company: undefined, position: undefined, city: undefined, current_role: false, from_year: undefined, to_year: undefined })}>
                                    + Add more
                                </div>
                            </>)}
                        </FieldArray>
                    </div>

                    {/* Board */}
                    <div className='pf-section__title'>I am on board</div>
                    <div className='d-flex flex-column w-100'>
                        <FieldArray name="on_board">
                            {({ push, remove }) => (<>
                                <div className='d-flex flex-column w-100'>    
                                    {(formik.values.on_board ?? []).map((item, index) => (
                                        <div key={`on_board_${index}`} className={`pf-section mb-4 ${index>0 ? 'mt-4' : ''}`}>
                                            <div className='d-flex flex-row justify-content-between w-100'>
                                                <div className='pf-section__title'>Board {`(${index+1})`}</div>
                                                <button type="button" onClick={() => remove(index)} className="remove-btn tap-flex-center">
                                                    <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_delete.svg' />&nbsp;
                                                </button>
                                            </div>
                                            <div className={`pf-section__desc ${index>0 ? 'd-none' : ''}`}>
                                                List all relevant organizations
                                            </div>
                                            
                                            <div className='pf-fields'>
                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Organization</label>
                                                        <Field name={`on_board[${index}].company`} className='pf-input' />
                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Role</label>
                                                        <Field name={`on_board[${index}].position`} className='pf-input' />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`on_board[${index}].company`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`on_board[${index}].position`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='w-100 d-flex flex-row'>
                                                    <div className='recognition-form__field-wrapper w-100'>
                                                        <div className='pf-field'>
                                                            <label className='pf-label'>Description</label>
                                                        </div>
                                                        <div className='recognition-form__textarea-wrapper'>
                                                            <Field
                                                                as='textarea'
                                                                name={`on_board[${index}].description`}
                                                                maxLength={500}
                                                                className='recognition-form__textarea' />
                                                            </div>
                                                            <div className='recognition-form__counter'>
                                                            <span className='recognition-form__counter-placeholder'>
                                                                Description
                                                            </span>
                                                            <span className='recognition-form__counter-text'>
                                                                {formik.values.on_board[index]?.description?.length || 0}/500
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`on_board[${index}].description`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>City</label>
                                                    <CityAutocompleteField name={`on_board[${index}].city`} />
                                                    <ErrorMessage name={`on_board[${index}].city`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <label className='pf-checkbox' style={{ cursor: 'pointer' }}>
                                                    <Field type='checkbox' name={`on_board[${index}].current_role`} className='pf-check' />
                                                    <span>I am currently serving in this role</span>
                                                </label>

                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>From</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.from_year
                                                                ? dayjs(item.from_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `on_board[${index}].from_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />

                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>To</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.to_year
                                                                ? dayjs(item.to_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `on_board[${index}].to_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`on_board[${index}].from_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`on_board[${index}].to_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>Website url</label>
                                                    <Field name={`on_board[${index}].website`} className='pf-input' />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='pf-add' onClick={() => push({ company: undefined, position: undefined, city: undefined, current_role: false, from_year: undefined, to_year: undefined })}>
                                    + Add more
                                </div>
                            </>)}
                        </FieldArray>
                    </div>

                    {/* Nonprofit */}
                    <div className='pf-section__title'>Do you lead a nonprofit or charitable organization that you established or support?</div>
                    <div className='d-flex flex-column w-100'>
                        <FieldArray name="non_profit_involvement">
                            {({ push, remove }) => (<>
                                <div className='d-flex flex-column w-100'>    
                                    {(formik.values.non_profit_involvement ?? []).map((item, index) => (
                                        <div key={`non_profit_involvement_${index}`} className={`pf-section mb-4 ${index>0 ? 'mt-4' : ''}`}>
                                            <div className='d-flex flex-row justify-content-between w-100'>
                                                <div className='pf-section__title'>organization {`(${index+1})`}</div>
                                                <button type="button" onClick={() => remove(index)} className="remove-btn tap-flex-center">
                                                    <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_delete.svg' />&nbsp;
                                                </button>
                                            </div>
                                            
                                            <div className='pf-fields'>
                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Organization</label>
                                                        <Field name={`non_profit_involvement[${index}].company`} className='pf-input' />
                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Role</label>
                                                        <Field name={`non_profit_involvement[${index}].position`} className='pf-input' />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`non_profit_involvement[${index}].company`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`non_profit_involvement[${index}].position`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='w-100 d-flex flex-row'>
                                                    <div className='recognition-form__field-wrapper w-100'>
                                                        <div className='pf-field'>
                                                            <label className='pf-label'>Description</label>
                                                        </div>
                                                        <div className='recognition-form__textarea-wrapper'>
                                                            <Field
                                                                as='textarea'
                                                                name={`non_profit_involvement[${index}].description`}
                                                                maxLength={500}
                                                                className='recognition-form__textarea' />
                                                            </div>
                                                            <div className='recognition-form__counter'>
                                                            <span className='recognition-form__counter-placeholder'>
                                                                Description
                                                            </span>
                                                            <span className='recognition-form__counter-text'>
                                                                {formik.values.non_profit_involvement[index]?.description?.length || 0}/500
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`non_profit_involvement[${index}].description`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>City</label>
                                                    <CityAutocompleteField name={`non_profit_involvement[${index}].city`} />
                                                    <ErrorMessage name={`non_profit_involvement[${index}].city`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <label className='pf-checkbox' style={{ cursor: 'pointer' }}>
                                                    <Field type='checkbox' name={`non_profit_involvement[${index}].current_role`} className='pf-check' />
                                                    <span>I am currently serving in this role</span>
                                                </label>

                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>From</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.from_year
                                                                ? dayjs(item.from_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `non_profit_involvement[${index}].from_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />

                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>To</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.to_year
                                                                ? dayjs(item.to_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `non_profit_involvement[${index}].to_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`non_profit_involvement[${index}].from_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`non_profit_involvement[${index}].to_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>Website url</label>
                                                    <Field name={`non_profit_involvement[${index}].website`} className='pf-input' />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='pf-add' onClick={() => push({ company: undefined, position: undefined, city: undefined, current_role: false, from_year: undefined, to_year: undefined })}>
                                    + Add more
                                </div>
                            </>)}
                        </FieldArray>
                    </div>

                    {/* Education */}
                    <div className='pf-section__title'>Education</div>
                    <div className='d-flex flex-column w-100'>
                        <FieldArray name="education">
                            {({ push, remove }) => (<>
                                <div className='d-flex flex-column w-100'>    
                                    {(formik.values.education ?? []).map((item, index) => (
                                        <div key={`education_${index}`} className={`pf-section mb-4 ${index>0 ? 'mt-4' : ''}`}>
                                            <div className='d-flex flex-row justify-content-between w-100'>
                                                <div className='pf-section__title'>Education {`(${index+1})`}</div>
                                                <button type="button" onClick={() => remove(index)} className="remove-btn tap-flex-center">
                                                    <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_delete.svg' />&nbsp;
                                                </button>
                                            </div>
                                            <div className={`pf-section__desc ${index>0 ? 'd-none' : ''}`}>
                                                List all relevant universities and educational institutions.
                                            </div>
                                            
                                            <div className='pf-fields'>
                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Educational Institution</label>
                                                        <Field name={`education[${index}].university_name`} className='pf-input' />
                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>Degree</label>
                                                        <Field name={`education[${index}].degree`} className='pf-input' />
                                                        <ErrorMessage name={`education[${index}].degree`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`education[${index}].company`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`education[${index}].position`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='w-100 d-flex flex-row'>
                                                    <div className='recognition-form__field-wrapper w-100'>
                                                        <div className='pf-field'>
                                                            <label className='pf-label'>Description</label>
                                                        </div>
                                                        <div className='recognition-form__textarea-wrapper'>
                                                            <Field
                                                                as='textarea'
                                                                name={`education[${index}].description`}
                                                                maxLength={500}
                                                                className='recognition-form__textarea' />
                                                            </div>
                                                            <div className='recognition-form__counter'>
                                                            <span className='recognition-form__counter-placeholder'>
                                                                Description
                                                            </span>
                                                            <span className='recognition-form__counter-text'>
                                                                {formik.values.education[index]?.description?.length || 0}/500
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`education[${index}].description`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>City</label>
                                                    <CityAutocompleteField name={`education[${index}].city`} />
                                                    <ErrorMessage name={`education[${index}].city`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <label className='pf-checkbox' style={{ cursor: 'pointer' }}>
                                                    <Field type='checkbox' name={`education[${index}].current_role`} className='pf-check' />
                                                    <span>I am currently studying</span>
                                                </label>

                                                <div className='pf-row'>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>From</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.from_year
                                                                ? dayjs(item.from_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `education[${index}].from_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />

                                                    </div>
                                                    <div className='pf-field'>
                                                        <label className='pf-label'>To</label>
                                                        <DatePicker picker="year" className="underline-picker"
                                                            disabledDate={(current) =>
                                                                current && current > dayjs().endOf('year')
                                                            }
                                                            value={
                                                                item.to_year
                                                                ? dayjs(item.to_year.toString(), 'YYYY')
                                                                : null
                                                            }
                                                            onChange={(value) =>
                                                                formik.setFieldValue(
                                                                `education[${index}].to_year`,
                                                                value ? value.year() : null
                                                                )
                                                            } />
                                                    </div>
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`education[${index}].from_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`education[${index}].to_year`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>

                                                <div className='pf-field'>
                                                    <label className='pf-label'>Website url</label>
                                                    <Field name={`education[${index}].website`} className='pf-input' />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='pf-add' onClick={() => push({ university_name: undefined, degree: undefined, city: undefined, current_role: false, from_year: undefined, to_year: undefined })}>
                                    + Add more
                                </div>
                            </>)}
                        </FieldArray>
                    </div>

                    {/* Industries */}
                    <div className='pf-section'>
                        <div className='pf-section__title'>What industries do you have expertise in?</div>
                        <div className='pf-field'>
                            <label className='pf-label'>Select relevant industries</label>
                            <IndustriesAutocompleteField
                                values={formik?.values?.industries}
                                onChange={setSelectedIndustries}
                            />
                        </div>
                    </div>

                    {/* Interests */}
                    <div className='pf-section'>
                        <div className='pf-section__title'>Please indicate your key Professional Interests</div>
                        <div className='pf-section__desc italic'>Select all that apply</div>

                        <div className='pf-interests'>
                            {allInterests.map((interest) => (
                                <div
                                    key={interest}
                                    className={`pf-chip ${formik.values.professional_interest.includes(interest) ? 'is-selected' : ''}`}
                                    onClick={() => toggleInterest(interest)}
                                >
                                    {interest}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Actions */}
                    <div className='pf-actions'>
                        <button type='reset' className='pf-btn pf-btn--cancel' onClick={() => { navigate.goBack() }}>
                            Cancel
                        </button>

                        <button
                            type='button'
                            className='btn nb-btn-primary'
                            disabled={loading}
                            aria-busy={loading ? 'true' : 'false'}
                            aria-live='polite'
                            onClick={focusFirstError} >
                            {!loading ? (
                                <>
                                    <span className='nb-heading-md'>save changes</span>
                                    <img
                                        src='/media/svg/nobilis/vector1.svg'
                                        alt=''
                                        className='nb-btn-icon nb-btn-icon--white'
                                    />
                                </>
                            ) : (
                                <span className='indicator-progress nb-heading-md'>
                                    Please wait...
                                    <span
                                        className='spinner-border spinner-border-sm align-middle ms-2'
                                        role='status'
                                        aria-hidden='true'
                                    />
                                </span>
                            )}
                        </button>
                    </div>
                </Form>)
            }}
        </Formik>
        <RequiredInfoModal open={showModal} message={messageModal} onClose={() => setShowModal(false)} />
    </>)
}
